export { default as CollectionOutlineIcon } from './CollectionOutlineIcon';
